import BankAccountConfigurationPage from "./BankAccountConfigurationPage";
import ConfigurationPage from "./ConfigurationPage";
import TransactionsPageSwitcher from "./Payables/TransactionsPageSwitcher";
import PayeesPage from "./PayeesPage";
import PaymentsPage from "./PaymentsPage";
import CancelPaymentBatch from "./TreasuryPlatformManagement/CancelPaymentBatch";
import LinkEpAndIpd from "./TreasuryPlatformManagement/LinkEpAndIpd";
import ModifyPaymentStatus from "./TreasuryPlatformManagement/ModifyPaymentStatus";
import OnboardBankAccount from "./TreasuryPlatformManagement/OnboardBankAccount";
import QueryPaymentBatch from "./TreasuryPlatformManagement/QueryPaymentBatch";
import QueryProcessingPayments from "./TreasuryPlatformManagement/QueryProcessingPayments";
import QueryProviderObject from "./TreasuryPlatformManagement/QueryProviderObject";
import ReconciliationGaps from "./TreasuryPlatformManagement/ReconciliationGaps";
import RecreateOutgoingPayment from "./TreasuryPlatformManagement/RecreateOutgoingPayment";
import SetBankAccountVerificationStatus from "./TreasuryPlatformManagement/SetBankAccountVerificationStatus";

export type TreasuryRoute = {
  path: string | string[];
  component: React.ComponentType;
};

export const TREASURY_ROUTES: TreasuryRoute[] = [
  // React Router v5 array path keeps the component mounted across all URL patterns,
  // preventing remounts when navigating between list, slideout, pay, and review views.
  // TransactionsPageSwitcher renders TransactionsPage (flag ON) or DistributionsPage (flag OFF)
  // based on the `treasuryPaymentIntegration` feature flag.
  {
    path: [
      "/treasury/transactions/:transactionBatchId/:paymentBatchId/review",
      "/treasury/transactions/:transactionBatchId/pay",
      "/treasury/transactions/:transactionBatchId?",
    ],
    component: TransactionsPageSwitcher,
  },
  { path: "/treasury/payees/:payeeId?", component: PayeesPage },
  // Optional param keeps PaymentsPage mounted when navigating between list and detail views,
  // preventing unnecessary remounts and data refetching when opening/closing the drawer
  { path: "/treasury/payments/:paymentBatchId?", component: PaymentsPage },
  { path: "/treasury", component: PaymentsPage }, // Must be last (catch-all)
];

export const CONFIGURATION_ROUTES: TreasuryRoute[] = [
  {
    path: "/treasury/configuration/set-bank-account-verification-status",
    component: SetBankAccountVerificationStatus,
  },
  { path: "/treasury/configuration/query-provider-object", component: QueryProviderObject },
  { path: "/treasury/configuration/cancel-payment-batch", component: CancelPaymentBatch },
  { path: "/treasury/configuration/reconciliation-gaps", component: ReconciliationGaps },
  { path: "/treasury/configuration/link-ep-and-ipd", component: LinkEpAndIpd },
  { path: "/treasury/configuration/query-payment-batch", component: QueryPaymentBatch },
  {
    path: "/treasury/configuration/query-processing-payments",
    component: QueryProcessingPayments,
  },
  { path: "/treasury/configuration/onboard-bank-account", component: OnboardBankAccount },
  {
    path: "/treasury/configuration/recreate-outgoing-payments",
    component: RecreateOutgoingPayment,
  },
  {
    path: "/treasury/configuration/modify-payment-status",
    component: ModifyPaymentStatus,
  },
  {
    path: "/treasury/configuration/bank-accounts",
    component: BankAccountConfigurationPage,
  },
  { path: "/treasury/configuration", component: ConfigurationPage },
];
